import eventType from '../../shares/enums/eventType';
import eventEmitters from '../../shares/lib/eventEmitters';
import { ResponseSource } from '../../shares/types/SwipeSDKConfigType';
import { renderGameUI } from './renderGameUI';

const renderPlaceHolderUI = (ResponseSource: ResponseSource) => {
  const { placeHolderDom, gameData } = ResponseSource;
  let elementToAppend: HTMLElement | null = null;

  const loaderIcon = document.querySelector(
    '#mini-game-root #mini-game-spinner',
  ) as HTMLElement;

  const miniGameIframeContainer = document.querySelector(
    '#mini-game-root #mini-game-frame',
  );

  if (typeof placeHolderDom === 'string') {
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = placeHolderDom;
    elementToAppend = tempContainer.firstElementChild as HTMLElement | null;
  } else if (placeHolderDom instanceof HTMLElement) {
    elementToAppend = placeHolderDom;
  }

  if (elementToAppend) {
    if (gameData) {
      elementToAppend.addEventListener('click', async () => {
        loaderIcon.style.display = 'block';

        eventEmitters(eventType.MINIGAME_COVERCLICK, 'MiniGame', {
          gameId: gameData,
          eventType: eventType.MINIGAME_COVERCLICK,
        });

        renderGameUI(ResponseSource);
      });
    }

    if (miniGameIframeContainer) {
      miniGameIframeContainer.replaceChildren(elementToAppend);
      if (loaderIcon) {
        loaderIcon.style.display = 'none';
      }
    }
  }
};

export default renderPlaceHolderUI;
